<template>
  <div class="component" v-if="homeSalesTraining">

    <!-- heading -->
    <el-row>
      <el-col :span="24" :offset="0">
        <div>
          <div class="header-container">
            <h2 class="heading">{{ homeSalesTraining.salesTrainingHeadline }}</h2>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- top section -->
    <el-row>
      <el-col :xs="{ span: 22, offset: 1, }" :sm="{ span: 22, offset: 1, }" :md="{ span: 22, offset: 1, }"
        :lg="{ span: 22, offset: 1, }" :xl="{ span: 20, offset: 2, }">
        <div class="top-flex-wrapper">

          <!-- copy section -->
          <div class="top-flex-section top-left-section">
            <p>{{ homeSalesTraining.salesTrainingSubhead }} </p>
            <span v-html="homeSalesTraining.salesTrainingDescription">

            </span>
            <router-link :to="{ name: 'Training' }">
              <button class="el-button el-button--primary">
                {{ homeSalesTraining.salesTrainingCtaText }}
              </button>
            </router-link>
          </div>

          <!-- certificate section -->
          <div class="top-flex-section top-right-section">
            <div class="certificates-header">
              <h3>{{ $t('trainingMyCertificates') }}</h3>
            </div>

            <div v-for="certificate in certificateData" v-bind:key="certificate.name" class="certificate-info">
              <div class="certificate-summary">
                <div class="certificate-checkbox">
                  <img v-if="certificate.completed" src="@/assets/images/red-check-box.svg">
                  <img v-else src="@/assets/images/grey-check-box.svg">
                </div>
                <div class="certificate-copy">
                  <h4>{{ certificate.name }}</h4>
                  <p>{{
                    $t('trainingCompletedCount', {
                      completed: completedCoursesByCertificate(certificate.name).length,
                      total: certificate.courses.length
                    })
                  }}</p>
                </div>
              </div>
              <div class="certificate-incomplete" v-if="!certificate.completed">
                <div class="certificate-tracker tracker">
                  <div class="tracker-fill" :style="{
                    width: `${completedCoursesByCertificate(certificate.name).length / certificate.courses.length * 100}%`
                  }">
                  </div>
                  <span class="tracker-dot" :style="{
                    left: `calc(${completedCoursesByCertificate(certificate.name).length / certificate.courses.length * 100}% - 7px)`
                  }">
                  </span>
                </div>
                <div class="certificate-link">
                  <router-link :to="{ name: 'Training' }" class="arrow">
                    {{ $t('trainingViewAll') }}
                  </router-link>
                </div>
              </div>
            </div>

          </div>
        </div>
      </el-col>
    </el-row>

    <!-- bottom section -->
    <!-- empty state - no trainings in progress -->
    <el-row v-if="!inProgressCourses.length">
      <el-col :span="24" :offset="0">

        <div class="bottom-flex-wrapper">

          <!-- video unselected - thumbnail -->
          <div class="bottom-flex-section" v-if="!emptyStateVidSelected">

            <el-row>
              <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 22, offset: 1 }"
                :lg="{ span: 22, offset: 2 }" :xl="{ span: 22, offset: 2 }">
                <div v-on:click="emptyStateVidSelected = !emptyStateVidSelected"
                  :style="{ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.05) 0%, rgb(0, 0, 0, 0.6) 100%), url(' + emptyStateVideoImage + ')' }"
                  class="thumbnail-wrap">
                  <div class="thumbnail-container">
                    <div class="thumbnail-copy">
                      <h3>{{ homeSalesTraining.trainingFeaturesEmptyStateVideoHeadline }}</h3>
                      <p>{{ homeSalesTraining.trainingFeaturesEmptyStateVideoSubhead }}</p>
                    </div>

                    <!-- video icon -->
                    <svg class="video-icon" width="37" height="25" viewBox="0 0 37 25" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M35.1167 2.28167C34.6484 2.03151 34.1211 1.91289 33.5908 1.93842C33.0605 1.96395 32.5471 2.13268 32.105 2.42667L26.6667 6.05167V4.19833C26.6653 3.08527 26.2226 2.01818 25.4355 1.23113C24.6485 0.444072 23.5814 0.00132324 22.4683 0H4.19833C3.08527 0.00132324 2.01818 0.444072 1.23112 1.23113C0.444071 2.01818 0.00132324 3.08527 0 4.19833V20.8017C0.00132324 21.9147 0.444071 22.9818 1.23112 23.7689C2.01818 24.5559 3.08527 24.9987 4.19833 25H22.4683C23.5814 24.9987 24.6485 24.5559 25.4355 23.7689C26.2226 22.9818 26.6653 21.9147 26.6667 20.8017V18.9483L32.105 22.5733C32.547 22.8676 33.0605 23.0365 33.5909 23.062C34.1212 23.0874 34.6486 22.9686 35.1167 22.718C35.5849 22.4674 35.9762 22.0945 36.2492 21.6391C36.5221 21.1836 36.6664 20.6626 36.6667 20.1317V4.86833C36.6663 4.33732 36.522 3.81635 36.249 3.36086C35.9761 2.90537 35.5848 2.5324 35.1167 2.28167ZM23.3333 20.8017C23.3333 21.0311 23.2422 21.2511 23.08 21.4133C22.9178 21.5755 22.6977 21.6667 22.4683 21.6667H4.19833C3.96892 21.6667 3.74891 21.5755 3.58669 21.4133C3.42447 21.2511 3.33333 21.0311 3.33333 20.8017V4.19833C3.33333 3.96892 3.42447 3.7489 3.58669 3.58669C3.74891 3.42447 3.96892 3.33333 4.19833 3.33333H22.4683C22.6977 3.33333 22.9178 3.42447 23.08 3.58669C23.2422 3.7489 23.3333 3.96892 23.3333 4.19833V20.8017ZM33.3333 19.3867L26.6667 14.9417V10.0583L33.3333 5.61333V19.3867Z"
                        fill="white" />
                    </svg>
                  </div>

                </div>
              </el-col>
            </el-row>

          </div>

          <!-- video selected -->
          <div v-else class="bottom-flex-section">
            <el-row>
              <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 22, offset: 1 }"
                :lg="{ span: 22, offset: 2 }" :xl="{ span: 22, offset: 2 }">
                <div class="video-wrap">
                  <iframe class="video"
                    :src="`https://player.vimeo.com/video/${emptyStateVideoIdWithParams}byline=0&title=0&portrait=0&color=e50b19&autoplay=1`"
                    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen webkitallowfullscreen
                    mozallowfullscreen>
                  </iframe>
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- empty state features and benefits copy -->
          <div class="bottom-flex-section empty-state-wrapper">
            <div class="bottom-heading-container">
              <h2>{{ homeSalesTraining.trainingFeaturesEmptyStateHeadline }}</h2>
            </div>
            <el-row>
              <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 22, offset: 1 }"
                :lg="{ span: 18, offset: 3 }" :xl="{ span: 18, offset: 3 }">
                <div class="empty-state-copy">
                  <p class="empty-state-subhead">{{ homeSalesTraining.trainingFeaturesEmptyStateSubhead }}</p>
                  <div v-html="homeSalesTraining.trainingFeaturesEmptyStateCopy" class="empty-state-description">
                  </div>
                </div>
              </el-col>
            </el-row>

          </div>
        </div>
      </el-col>
    </el-row>

    <!-- trainings in progress -->
    <el-row v-else>
      <el-col :span="24" :offset="0">
        <el-row>
          <el-col :span="24" :offset="0" class="in-progress-headline">
            <h3>{{ homeSalesTraining.salesTrainingInProgressHeadline }}</h3>
          </el-col>
        </el-row>
        <el-row class="in-progress-row" type="flex">
          <el-col :xs="{ span: 12 }" :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 6 }" :xl="{ span: 6 }"
            v-for="course in displayedInProgress" v-bind:key="course.id" class="in-progress-course">
            <div class="course-info">
              <h4>{{ course.title }}</h4>
              <p>{{ $t('trainingCompletedPercent', { percent: course.percent }) }}</p>
              <div class="course-tracker tracker">
                <div class="tracker-fill" :style="{
                  width: `${course.percent}%`
                }">
                </div>
                <span class="tracker-dot" :style="{
                  left: `calc(${Number(course.percent)}% - 7px)`
                }">
                </span>
              </div>
            </div>
            <a :href="course.url" class="arrow course-link">
              {{ $t('trainingContinue') }}
            </a>
          </el-col>
          <el-col class="" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 12 }" :xl="{ span: 12 }">


            <!-- video unselected - thumbnail -->
            <div v-if="!inProgressVidSelected">
              <el-row>
                <el-col :span="24">
                  <div v-on:click="inProgressVidSelected = !inProgressVidSelected"
                    :style="{ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.05) 0%, rgb(0, 0, 0, 0.6) 100%), url(' + inProgressVideoImage + ')' }"
                    class="thumbnail-wrap">
                    <div class="thumbnail-container">
                      <div class="thumbnail-copy">
                        <h3>{{ homeSalesTraining.salesTrainingBenefitsHeadline }}</h3>
                      </div>

                      <!-- video icon -->
                      <svg class="video-icon" width="37" height="25" viewBox="0 0 37 25" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M35.1167 2.28167C34.6484 2.03151 34.1211 1.91289 33.5908 1.93842C33.0605 1.96395 32.5471 2.13268 32.105 2.42667L26.6667 6.05167V4.19833C26.6653 3.08527 26.2226 2.01818 25.4355 1.23113C24.6485 0.444072 23.5814 0.00132324 22.4683 0H4.19833C3.08527 0.00132324 2.01818 0.444072 1.23112 1.23113C0.444071 2.01818 0.00132324 3.08527 0 4.19833V20.8017C0.00132324 21.9147 0.444071 22.9818 1.23112 23.7689C2.01818 24.5559 3.08527 24.9987 4.19833 25H22.4683C23.5814 24.9987 24.6485 24.5559 25.4355 23.7689C26.2226 22.9818 26.6653 21.9147 26.6667 20.8017V18.9483L32.105 22.5733C32.547 22.8676 33.0605 23.0365 33.5909 23.062C34.1212 23.0874 34.6486 22.9686 35.1167 22.718C35.5849 22.4674 35.9762 22.0945 36.2492 21.6391C36.5221 21.1836 36.6664 20.6626 36.6667 20.1317V4.86833C36.6663 4.33732 36.522 3.81635 36.249 3.36086C35.9761 2.90537 35.5848 2.5324 35.1167 2.28167ZM23.3333 20.8017C23.3333 21.0311 23.2422 21.2511 23.08 21.4133C22.9178 21.5755 22.6977 21.6667 22.4683 21.6667H4.19833C3.96892 21.6667 3.74891 21.5755 3.58669 21.4133C3.42447 21.2511 3.33333 21.0311 3.33333 20.8017V4.19833C3.33333 3.96892 3.42447 3.7489 3.58669 3.58669C3.74891 3.42447 3.96892 3.33333 4.19833 3.33333H22.4683C22.6977 3.33333 22.9178 3.42447 23.08 3.58669C23.2422 3.7489 23.3333 3.96892 23.3333 4.19833V20.8017ZM33.3333 19.3867L26.6667 14.9417V10.0583L33.3333 5.61333V19.3867Z"
                          fill="white" />
                      </svg>
                    </div>
                  </div>
                </el-col>
              </el-row>

            </div>

            <!-- video selected -->
            <div v-else>
              <el-row>
                <el-col :span="24">
                  <div class="video-wrap">
                    <iframe class="video"
                      :src="`https://player.vimeo.com/video/${inProgressVideoIdWithParams}byline=0&title=0&portrait=0&color=e50b19&autoplay=1`"
                      frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen
                      webkitallowfullscreen mozallowfullscreen>
                    </iframe>
                  </div>
                </el-col>
              </el-row>
            </div>

          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import training from '@/components/training';
import home from './';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      emptyStateVidSelected: false,
      inProgressVidSelected: false,
    }
  },
  computed: {
    ...mapState(training.store.namespace, [
      'courseCatalog',
      'usersCourses',
      'inProgressCourses',
      'fullLineCertifications',
    ]),
    ...mapState(home.store.namespace, [
      'homeSalesTraining',
    ]),
    certificateData() {
      // this logic assumes that the name in fullLineCertfications.title
      // matches how it appears in the courseCatalog.fullLine
      let fullLineCertificationNames = this.fullLineCertifications.map(fullLineCert => fullLineCert.title)
      let certificates = []
      let certificateData = []
      this.courseCatalog.forEach((course) => {
        if (!certificates.includes(course.fullLine)) {
          certificates.push(course.fullLine)
          certificateData.push({
            name: course.fullLine,
            courses: this.courseCatalog.filter((course2) => {
              return course2.fullLine === course.fullLine
            }),
            completed: fullLineCertificationNames.includes(course.fullLine),
          })
        }
      })
      return certificateData
    },
    completedCourses() {
      return this.usersCourses.filter((course) => {
        return course.completed
      })
    },
    emptyStateVideoImage() {
      return this.homeSalesTraining.trainingFeaturesEmptyStateVideoImage[0] ? this.homeSalesTraining.trainingFeaturesEmptyStateVideoImage[0].url : ''
    },
    emptyStateVideoIdWithParams() {
      return this.parseURL(this.homeSalesTraining.trainingFeaturesEmptyStateVideoLink)
    },
    inProgressVideoImage() {
      return this.homeSalesTraining.salesTrainingBenefitsImage[0] ? this.homeSalesTraining.salesTrainingBenefitsImage[0].url : ''
    },
    inProgressVideoIdWithParams() {
      return this.parseURL(this.homeSalesTraining.salesTrainingBenefitsVideoLink)
    },
    displayedInProgress() {
      let inProgressCopy = this.inProgressCourses.slice()
      return inProgressCopy.sort((a, b) => Number(b.percent) - Number(a.percent)).slice(0, 2)
    }
  },
  methods: {
    completedCoursesByCertificate(certificate) {
      let individualCertificate = this.certificateData.filter((cert) => {
        return cert.name === certificate
      })[0]
      let certificateCourseIds = individualCertificate.courses.map((course) => course.id)
      let completedCoursesFiltered = this.completedCourses.filter((course) => {
        return certificateCourseIds.includes(course.id)
      })
      return completedCoursesFiltered
    },
    parseURL(fullURL) {
      if (!fullURL) {
        return ''
      }
      let idWithParamsLocation = fullURL.indexOf('.com/') + 5
      let idWithParams = fullURL.slice(idWithParamsLocation)
      if (idWithParams.includes('?')) {
        idWithParams += '&'
      } else {
        idWithParams += '?'
      }
      return idWithParams
    }
  },
  name: 'HomeSalesTraining',
}

</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';
@import '@/assets/base/_variables.scss';

.header-container {
  background-image: url('@/assets/images/large-rectangle-background.svg');
  background-repeat: no-repeat;
  background-size: cover;
  width: 40%;
  padding: 30px 0px 30px 40px;
  margin-bottom: 30px;

  @include res(md-and-down, $--breakpoints-spec) {
    background-size: cover;
    width: 90%;
  }
}

.component {
  padding: 50px 0px;
}

.heading {
  color: $--color-white;
}

.top-flex-wrapper {
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: 100px;

  @include res(md-and-down, $--breakpoints-spec) {
    flex-wrap: wrap;
    margin-bottom: 0px;
  }
}

.top-flex-section {
  width: 50%;

  @include res(md-and-down, $--breakpoints-spec) {
    width: 100%
  }
}

:deep(.top-left-section) {
  padding-right: 100px;

  @include res(md-and-down, $--breakpoints-spec) {
    margin-bottom: 30px;
  }

  p {
    color: $--color-secondary;
    text-transform: uppercase;
    font-family: $font-family-headings;
    font-weight: bold;
  }

  ul {
    list-style: none;
    padding-left: 0;

    li {
      padding-left: 2em;
      padding-top: 0.25em;
      margin-bottom: 0.5em;
      display: block;
      position: relative
    }

    li::before {
      content: '';
      position: absolute;
      left: 0;
      top: 6px;
      width: 20px;
      height: 20px;
      background-repeat: no-repeat;
      background-image: url('@/assets/images/check-blue.svg')
    }
  }

  button {
    padding: 20px 35px;
    font-size: 14px;
  }
}

.top-right-section {
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.11);
  padding: 35px 50px;

  @include res(md-and-down, $--breakpoints-spec) {
    margin-bottom: 35px;
  }
}

.bottom-flex-wrapper {
  display: flex;
  flext-wrap: nowrap;

  @include res(md-and-down, $--breakpoints-spec) {
    flex-wrap: wrap;
  }
}

.bottom-flex-section {
  width: 50%;

  @include res(md-and-down, $--breakpoints-spec) {
    width: 100%;
  }
}

.bottom-heading-container {
  background-image: url('@/assets/images/reversed-heading-background.svg');
  background-repeat: no-repeat;
  background-size: cover;
  padding: 30px 0px 30px 60px;

  h2 {
    color: $--color-white;
  }

  @include res(md-and-down, $--breakpoints-spec) {
    background-image: url('@/assets/images/large-rectangle-background.svg');
    padding: 30px 0px 30px 40px;
    width: 90%;
  }
}

.certificates-header {
  h3 {
    text-transform: uppercase;
    color: $--color-secondary;
    margin-bottom: 0px;
  }
}

.certificate-incomplete {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.certificate-tracker {
  width: 50%;
}

.course-tracker {
  width: 75%;
  margin-bottom: 10px;
}

.tracker {
  background-color: $--color-grayscale-2;
  height: 8px;
  border-radius: 4px;
  position: relative;
}

.tracker-fill {
  background-color: $--color-secondary-light;
  height: 100%;
  border-radius: 4px;
}

.tracker-dot {
  background-color: $--color-secondary;
  position: absolute;
  top: calc((8px - 14px) / 2);
  height: 14px;
  width: 14px;
  border-radius: 7px;
}

.certificate-link {
  width: 35%;
}

.certificate-info {
  border-top: 1px solid $--color-grayscale-3;
  padding-top: 38px;
  margin-top: 20px;
}

.certificate-summary {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  gap: 15px;
}

.certificate-copy {
  h4 {
    color: $--color-secondary;
    text-transform: uppercase;
  }

  p {
    color: $--color-secondary;
    text-transform: uppercase;
    font-weight: bold;
    font-family: $font-family-headings;
    margin-top: 0.5rem;
    margin-bottom: 0;
  }
}

.certificate-checkbox {
  width: 10%;

  img {
    width: 100%;
  }
}

.empty-state-copy {}

.empty-state-subhead {
  color: $--color-secondary;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 22px;
  font-family: $font-family-headings;
}

.empty-state-description {
  color: $--color-grayscale-5;
}

.thumbnail-wrap {
  background-size: cover;
  background-repeat: none;
  background-color: $--color-grayscale-5;

  @include res(md-and-down, $--breakpoints-spec) {
    margin-bottom: 35px;
  }
}

:deep(.thumbnail-container) {
  cursor: pointer;
  padding: 40% 0 0 0;
  position: relative;

  p,
  h3 {
    color: $--color-white;
  }

  &:hover {
    box-shadow: 0px 8px 50px rgba(0, 0, 0, 0.3);

    p,
    h3 {
      color: $--color-grayscale-3;
    }
  }
}

.thumbnail-copy {
  h3 {
    text-transform: uppercase;
    margin-bottom: 0.5rem;
    font-size: 25px;
  }

  p {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  padding-left: 30px;
  padding-bottom: 30px;
  padding-right: 30px;
}

.video-icon {
  position: absolute;
  top: 30px;
  right: 30px;
}

.video-wrap {
  padding: 55% 0 0 0;
  position: relative;

  @include res(md-and-down, $--breakpoints-spec) {
    margin-bottom: 35px;
    padding: 67% 0 0 0;
  }
}

.video {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.in-progress-headline {
  text-align: center;
  margin-bottom: 40px;

  h3 {
    color: $--color-secondary;
    font-size: 40px;
  }
}

.in-progress-course {
  /*  padding: 90px 35px 35px 35px; */
  position: relative;
  background-color: $--color-white;
  border: 1px solid $--color-grayscale-1;
  display: flex;
  flex-wrap: wrap;

  &:hover {
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.2);
    z-index: 10;
  }

  p {
    font-family: $font-family-headings;
    font-weight: bold;
    text-transform: uppercase;
    color: $--color-grayscale-5;
  }

  h4 {
    text-transform: uppercase;
    font-size: 22px;
    color: $--color-secondary;
  }

}

.in-progress-row {
  align-items: stretch;
  flex-wrap: wrap;
}

.course-link {
  align-self: flex-end;
  padding: 35px 35px 35px 35px;
  width: 100%;

  &:hover {
    /* same as primary, primary not overriding element */
    background-color: #e50b19;
    color: $--color-white;
  }

  &:hover::after {
    background-color: $--color-white;
  }
}

.course-info {
  width: 100%;
  padding: 90px 35px 0px 35px;
}

.empty-state-wrapper {
  padding-left: 4vw;

  @include res(md-and-down, $--breakpoints-spec) {
    padding-left: 0;
    order: -1;
  }
}
</style>

